<div class="wrapper"
  [ngClass]="{
    'align-right': alignRight,
    'has-padding': hasPadding,
    'statement-column': isStatementColumn
  }"
  >
  @if (!editing || isEditingDisabled) {
    <div class="display"
         [appBsTooltip]="formattedValue"
         [onlyWhenTruncated]="true"
         (dblclick)="startEditing($event)">
      <app-comment-present-indicator [sourceComments]="sourceComments"
      ></app-comment-present-indicator>
      <span>{{formattedValue}}</span>
      <span class="icon-wrapper" [ngClass]="{'d-none': !invertValue && !footnotePresent && !isUserAddedRow}">
        <span [ngClass]="{'d-none': !invertValue }">
          <i class="fas fa-circle-minus"
          [appBsTooltip]="'This line item is inverted and subtracting from the total'"></i>
        </span>
        <span [ngClass]="{'d-none': !footnotePresent, 'ps-2': invertValue }">
          <i class="fas fa-file-lines"
          [appBsTooltip]="'This line item is associated with a footnote'"></i>
        </span>
        <span [ngClass]="{'d-none': !isUserAddedRow || isOffsetLinkRow, 'ps-2': invertValue || footnotePresent}">
          <i class="fas fa-user-pen"
          [appBsTooltip]="'This line item was manually added by a user and will be automatically added to future spreads'"></i>
        </span>
        <span [ngClass]="{'d-none': !isOffsetLinkRow, 'ps-2': invertValue || footnotePresent}">
          <i class="fas fa-link"
          [appBsTooltip]="offsetLinkTooltip"></i>
        </span>
      </span>
    </div>
  }
  @if (editing) {
    <div class="edit">
      <input #inputField type="text" [placeholder]="placeholder" (keydown)="checkForEnter($event)" [(ngModel)]="currentValue" (click)="stopPropagation($event)"/>
    </div>
  }
</div>
